export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-heading text-2xl lg:text-3xl font-bold">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, accent = "text-[hsl(var(--ring))]", testid }) {
  return (
    <div className="p-5 rounded-xl border border-border bg-card" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-sm text-muted-foreground">{label}</span>
        {Icon && <Icon className={`w-4 h-4 ${accent}`} />}
      </div>
      <p className="font-heading text-2xl font-bold mt-2">{value}</p>
    </div>
  );
}

export function EmptyState({ title, desc, action }) {
  return (
    <div className="text-center py-16 border border-dashed border-border rounded-xl">
      <p className="font-heading font-semibold text-lg">{title}</p>
      {desc && <p className="text-sm text-muted-foreground mt-1 max-w-md mx-auto">{desc}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function Loading() {
  return <div className="py-20 text-center text-muted-foreground">Chargement…</div>;
}
